import axios from "axios";
import { API_BASE_URL } from "./config";

// Single axios instance for every request made by an extracted feature block.
//
// `withCredentials` is set once here. The API authenticates with an HttpOnly
// session cookie, and the legacy call sites set the flag inconsistently - most
// omit it entirely, which is why several endpoints only ever worked when the
// browser happened to send the cookie anyway.
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Auth failures are TAGGED, not acted on.
//
// Logging out from inside the interceptor would run before the caller's own
// catch block, which would race the epoch guard in AuthContext and swallow
// errors the caller still needs to roll back optimistic UI. Tagging keeps the
// detection in one place while leaving each caller's control flow untouched.
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      error.isAuthError = true;
    }
    return Promise.reject(error);
  },
);

// True when a rejected request failed because the session is gone, rather than
// because the server or the network misbehaved. Callers use this to decide
// between "log the user out" and "keep the cached state and show an error".
export const isAuthError = (error) => error?.isAuthError === true;

export default apiClient;
